import React, { useState } from 'react';
import RightChart from './RightChart';
import './index.scss';
import LeftMetrics, { MetricItemType, METRICS_LIST } from './LeftMetrics';
import useVersionCardData from '../../hooks/useVersionCardData';
import CardCommon from '@op/components/CardCommon';
import { useFontLoading } from '@op/hooks/common';

export default function DataForm({ gameInfo, filter }: any) {
  const [selectMetric, serSelectMetric] = useState<MetricItemType>(
    METRICS_LIST[0],
  );
  const { loading, cardData } = useVersionCardData({ filter }); 
  const {changeLoading, loading: rightLoading} = useFontLoading();

  function changeSelectMetric(item: any) {
    serSelectMetric(item);
    changeLoading();
  }

  return (
    <CardCommon
      contentCard
      loading={loading}
      loadingHeight={420}
      className="dbo-data-form-wrapper"
    >
      <LeftMetrics
        serSelectMetric={changeSelectMetric}
        selectMetric={selectMetric}
        data={cardData}
      ></LeftMetrics>
      {/* 图表数据 */}
      <CardCommon
        contentCard
        loading={rightLoading || loading}
        loadingHeight={426}
        className="dbo-right-chart-cardCommon"
      >
        <RightChart
          filter={filter}
          metricItem={selectMetric}
          gameInfo={gameInfo}
        ></RightChart>
      </CardCommon>
    </CardCommon>
  );
}
